<script setup lang="ts">
import Gauge from '../parts/Gauge.vue';
defineProps<{
  hasNoData?: boolean;
}>();
</script>
<template>
  <div class="relative h-full flex flex-col bg-[#F9FAFB] rounded-[8px]">
    <div
      v-if="hasNoData"
      class="absolute top-45% left-0 text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold"
    >
      There are no new responses. <br />Please check again later.
    </div>
    <div
      class="ml-4 mb-2 mt-2 mr-4 w-[100%] font-bold xl:text-4 2xl:text-6 3xl:text-10 text-lg 2xl:mt-4 2xl:ml-6 3xl:mt-8 3xl:ml-10"
    >
      <div class="inline-block loading-gradient h-100% w-33% rounded-2"></div>
    </div>
    <Gauge class="w-100% h-100% mt-auto mb-auto" :value="0.4" :is-skeleton="true"></Gauge>
    <div
      class="rounded-[4px] mb-2 mt-2 ml-4 mr-4 bg-white border border-[#BDBDBD] xl:text-5 2xl:text-7 3xl:text-12 text-center text-[#333333] 2xl:ml-6 2xl:mr-6 2xl:mt-4 2xl:mb-6 3xl:mt-10 3xl:mr-12 3xl:ml-12 3xl:mb-8 3xl:rounded-[8px]"
    >
      <div class="inline-block font-bold loading-gradient h-50% w-33% rounded-2"></div>
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
}
</style>
